import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
};

export const counterSlice = createSlice({
  name: "workers",
  initialState,
  reducers: {
    setList: (state, action) => {
      state.list = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setList } = counterSlice.actions;

export default counterSlice.reducer;
